import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestLicenseDelete = {
    path: "/plugin-update/:slug/license/:blogId",
    method: RouteHttpVerb.DELETE
};
export { locationRestLicenseDelete };
